import { render, staticRenderFns } from "./cms-block-button.vue?vue&type=template&id=4553137b"
import script from "./cms-block-button.vue?vue&type=script&lang=js"
export * from "./cms-block-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports